import { createTheme } from "@mui/material";
const PwText = "Password";
const pwsText = "Passwords";

export const patterns = {
  //email regex pattern
  email:
  /^(?!.*\.\.)(?!.*--)(?!^\s)(?!^\-)(?!^\.)[a-zA-Z0-9!#$%&'*+/=?^_{|}~().,:;<>[\]\\" -]+(?<!-)(?<!\.)@([a-zA-Z0-9 ]+(?:-[a-zA-Z0-9 ]+)*)(\s*\.\s*[a-zA-Z]{2,})$/,
  //proposed phone number
  phoneNumber: /^\+?\d+$/,
  // username regex pattern
    username: 
      /^[a-zA-Z0-9@._-]+$/,
  //username not starts with numbers or special characters
    usernameStartWithAlphabets:
      /^[a-zA-Z][a-zA-Z0-9@._-]*$/,
    consecutiveDotsDashesUnderscores: 
      /^(?!.*(\.\.\.|---|___|@@@))/,
  // only Numbers
    onlyNumbers: 
      /^[0-9]+$/,
    alphabetSpace:
      /^[a-zA-Z]+(?: [a-zA-Z]+)*$/,
  //password regex pattern
    password:
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s)./,
    upperCasePassword:
      /^(?=.*[A-Z])/,
    lowerCasePassword:
      /^(?=.*[a-z])/,
    oneNumbers:
      /^(?=.*\d)/,
    oneSpecialCharacter:
      /[!@#$%^&*()_+\-=[\]{};':"\\|,`~.<>/?]+/,
    //only alphanumeric and space
    alphaNumericSpace:
    /^[a-zA-Z0-9]*(?: [a-zA-Z0-9]+)*$/,
    //only alphabets and numbers
    alphaNumeric:
    /^[a-zA-Z0-9]+$/,
    //only aplhanumeric
    onlyAlphaNumeric:
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/,
    websiteRegex:
     /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i,
    fileNameLengthRegex: /^.{1,100}$/,
    quizNameLengthRegex: /^.{1,100}$/,
    descriptionLengthRegex: /^.{1,500}$/,
    fileNameRegex: /^(?!.* {2})[a-z0-9.\-_ ]+$/i,
    consecutiveSpecialCharsRegex: /([@.\-_]){2,}/,
    filenameAtleast1Alpha:/[a-z0-9!@#$%^&*()_+{}\[\]:;"'<>,.?\/\\|-]/i,
    startingWithSpaces: /^(?!\s)[\s\S]*$/,
    alphabetAndNumber: /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/,
    NotStartWithNumber:/^(?!\d).*$/,
    phone : /^\d{10}$/
  };
  
  export const messages = {
    // validate messages
    fullname: "Full name is required",
    username: "Username is required",
    name: "Name is required",
    subject: "Main Subject is required",
    validName: "Name must only contain alphabets",
    validFullName: "Full name must only contain alphabets",
    validSubject: "Subject must only contain alphabets",
    firstName: "First Name is required",
    lastName: "Last Name is required",
    email: "Email is required",
    role: "Role is required",
    password: `${PwText} is required`,
    confirmPassword: "Confirm Password is required",
    validUsername: "Username must contain alphanumeric characters, '@', '.', '-', and '_'",
    noConsecutiveDotsDashesUnderscores: "Username cannot contain more than two consecutive '@', '.', '-', or '_'",
    validEmail: "Enter a valid email",
    invalidUsername: "Enter a valid username",
    invalidPassword: "Enter a valid password",
    invalidWebsite: "Enter a valid website",
    invalidDescription: "Enter a valid description",
    usernameMinLength: "Username should be atleast 6 characters",
    usernameMaxLength: "Username should not exceed 50 characters",
    validPassword:
      `${PwText} must contain atleast one uppercase letter, lowercase letter, number and special character`,
    passwordMatch: `${pwsText} must match`,
    passwordMinLength: `${PwText} should be atleast 8 characters`,
    passwordMaxLength: `${PwText} should not exceed 30 characters`,
    passwordOneUpperCase: `${PwText} must have atleast one uppercase letter`,
    passwordOneLowerCase: `${PwText} must have atleast one lowercase letter`,
    passwordOneNumber: `${PwText} must have atleast one number`,
    passwordOneSpecialCharater: `${PwText} must have atleast one special character`,
    schoolName: "Schoolname is required",
    validClassroomName:"Name must contain alphabets or alphanumeric characters",
    ClassroomNameNotStartWithNumber:"Name must not start with a number",
    title:"Title must contain alphabets or alphanumeric characters",
    titleNotStartWithNumber:"Title must not start with a number",
    titleLength:"Title must be between 1 and 100 characters long",
    validCode:"Code must only contain alphanumeric characters",
    website: "Website is required",
    usernameStartWithAlphabets:"Username must start with alphabets",
    fileNameLength:"File title must be between 1 and 100 characters long",
    subjectLength:"Subject must be between 1 and 100 characters long",
    authorNameLength:"Author name must be between 1 and 100 characters long",
    descriptionLength: "Description must be between 1 and 500 characters long",
    fileName:"File title may contains only alphabets, numbers, '-', '_', '.'",
    inBulkUploadfileName:"File title can contain only alphabets, numbers, '-', '_', '.'",
    authorName:"Author name may contains only alphabets, numbers, '-', '_', '.', '@'",
    consecutiveSpecialChars: "File title must not contain consecutive special characters",
    authorNameConsecutiveSpecialChars: "Author name must not contain consecutive special characters",
    filenameAtlease1Alpha: "File title must contain at least one alphabet",
    authorNameAtlease1Alpha: "Author name must contain at least one alphabet",
    quizName: "Quiz name is required",
    option: "Option is required",
    question: "Question is required",
    validOption: "Enter a valid Option",
    validQuestion: "Enter a valid Question",
    validQuizName: "Enter a valid Quiz Name",
    quizNameLength:"Quiz title must be between 1 and 100 characters long",
    quizNameContaines:"Quiz title may contains only alphabets, numbers, '-', '_', '.', '@'",
    quizConsecutiveSpecialChars: "Quiz title must not contain consecutive special characters",
    quiznameAtlease1Alpha: "Quiz title must contain at least one alphabet",
    LessonsTopic:"Lessons topic must contain alphabets or alphanumeric characters",
    VideoCategory:"Video category must contain alphabets or alphanumeric characters",
    LessonsTopicNotStartNumber: "Lessons topic must not start with a number",
    VideoCategoryNotStartNumber: "Video category must not start with a number",
    desription: "Description is required",
    desriptionLength: 'Description must be within 250 characters',
    titleRequired: "Title is required",
    meetingType: "Title is required",
    meetingTypeCharacter:"Title must contain alphabets or alphanumeric characters",
    meetingTypeNotStartWithNumber:"Title must not start with a number",
    meetingTypeLength:"Title must be between 1 and 100 characters long",
    validPhone : "must be 10 digits",
    requiredPhone : "Phone number is required",
    messages : 'Message is required',
    notificationdisable : "Enable notifications in the settings to view the notifications",
    validReferralCode:"Referral code must only contain alphanumeric characters",
    phoneNumberLength : "Phone number must contain a maximum of 20 digits",
    phoneNumberLength16 : "Phone number must contain a maximum of 16 digits  if not starts with '+'.",
    validPhoneNumber: "Phone number should be numeric and may include an optional '+' at the start.",
    meetingStartTime: "Start time must be at least 7 minutes in the future",
    multipleShareClassesMessage: "Are you sure you want to Share this file with your Class(es)?",
  };
  
  export const SCHOOL_ADMIN = 'schooladmin';
  export const TEACHER_ROLE = 'teacher';
  export const STUDENT_ROLE = 'student';
  export const PTA_ROLE = 'pta';
  export const NO_DATA_FOUND = 'No Data Found';
  export const CHIME = 'CHIME';
  export const JITSI = 'JITSI';
  export const VIRTUAL = 'VIRTUAL';
  export const PHYSICAL = 'PHYSICAL';
  export const JIBRI = 'JIBRI';
  export const BOT = 'BOT';
  export const CLASSROOM_S3_PATH = 'katon-classroom/';
  export const TAB_MAX_WIDTH = 768;

// To show advertisement image based on component
// const {classroomTabAdImage, rightSideAdFour} = images;
//   export const rightSideAdImages = [
//     rightSideAdFour,
//     rightSideAdFour,
//     classroomTabAdImage,
//     rightSideAdFour
//   ]


  export const theme= createTheme({
    components: {
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: "rgba(0,0,0,0.2)",
          },
        },
      },
    }}
  )

export const mediaServerUrl = process.env.REACT_APP_MEDIA_SERVER_URL;

export const selectRemedialClass = `This portal is for SHS students only. Are you an SHS student preparing to seat for WAEC?`;

export const  ALERT_MESSAGE_TWO_USERS= `You can only join the meeting from two devices. Please disconnect one device to join from this device.`

export const ALERT_MESSAGE_ALREADY_IN_MEETING= `You are currently in another meeting in a different window or tab.
Please end your active meeting before joining a new one.`;

export const LOGOUT_MESSAGE_IN_MEETING_HOST = `You are currently in an active meeting. Logging out will end your meeting for all participants.
Are you sure you want to log out?`;

export const LOGOUT_MESSAGE_IN_MEETING_PARTICIPANT = `You are still in a meeting. Logging out will disconnect you from the meeting. Are you sure you want to log out?`;

export const LOGOUT_MESSAGE_NOT_IN_MEETING = `Are you sure you want to log out?`;

// allowedTypes.ts
export const ALLOWED_MAP: Record<string, { mimes: string[] }> = {
  "Images": {
    mimes: ["image/jpeg", "image/png", "image/svg+xml", "image/jpg"],
  },

  "Syndicated Videos": {
    mimes: ["video/mp4"],
  },

  "Podcast": {
    mimes: ["audio/mpeg", "audio/wav", "audio/ogg"],
  },

  "E-books (Learning Materials)": {
    mimes: [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/epub+zip",
    ],
  },

  "E-books (Question Bank)": {
    mimes: ["text/csv"],
  },

  "E-books (Examination Guide)": {
    mimes: ["application/pdf"],
  },
};



export const ERROR_MESSAGES: Record<string, string> = {
  "Images": "Please select either jpg, jpeg, png or svg image(s)",
  "Syndicated Videos": "Please select MP4 file(s)",
  "Podcast": "Please select audio file(s)",
  "E-books (Learning Materials)": "Please select pdf, csv, ppt, epub or word file(s)",
  "E-books (Question Bank)": "Please select CSV file(s)",
  "E-books (Examination Guide)": "Please select PDF file(s)",
};


export const SCREEN_RECORDING = "screen-recording";
export const SCREEN_SHARING = "screen-sharing";
export const LIVE_UPDATE = "live-update";
export const HAND_RAISE = "hand-raise";
export const END_MEETING = "end-meeting";
export const YOU_ARE_PRESENTING_NOW = "You're presenting now.";
export const FACILITATOR_WORKSHOP_PATH = "/facilitator-workshop";
export const NO_OPTIONS = "no-options";
export const ARE_YOU_SURE_YOU_WANT_TO_END_THIS_SESSION = "Are you sure you want to End this Session?";
export const VIDEO_TILE_TEXT_SHADOW = "0 1px 2px rgba(0,0,0,.6),0 0 2px rgba(0,0,0,.3)";
export const INTER_FONT_FAMILY = "var(--font-inter)";
export const FONT_SIZE_XS = "var(--font-size-xs)";
export const COLOR_STEELBLUE = "var(--color-steelblue)";
export const BORDER_BOX_STYLE = "border-box";
export const SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR = "Subject not found for teacher";
export const SUBJECT_NOT_FOUND_ERROR = "Subject not found";
export const PATH_ADDRESSES = {
  STUDENT_CLASSROOM_PATH : "/student-classroom",
  TEACHER_CLASSROOM_PATH : "/teacher-classroom",
  PTA_MEETINGS_PATH : "/pta-meetings",
  ADMIN_DASHBOARD_PATH : "/admin-dashboard",
  TEACHER_PTA_PATH : "/teacher-pta",
  STUDENT_CLASSROOM_IMAGES_PATH : "/student-classroom/images",
  TEACHER_CLASSROOM_IMAGES_PATH : "/teacher-classroom/images",
  STUDENT_CLASSROOM_PODCAST_PATH : "/student-classroom/podcast",
  TEACHER_CLASSROOM_PODCAST_PATH : "/teacher-classroom/podcast",
  STUDENT_CLASSROOM_EBOOKS_PATH : "/student-classroom/ebooks",
  TEACHER_CLASSROOM_EBOOKS_PATH : "/teacher-classroom/ebooks",
  STUDENT_CLASSROOM_QUIZ_PATH : "/student-classroom/quiz",
  TEACHER_CLASSROOM_QUIZ_PATH : "/teacher-classroom/quiz",
  SCHOOL_PROFILE_PATH : "/school-profile"
}
export const CREATE_SCHEDULE_DATE_FORMAT = "YYYY-MM-DD";
export const COLOR_WHITE = "var(--color-white)";
export const FETCH_POLICY = "network-only";
export const FETCH_POLICY_NO_CACHE = "no-cache";
export const KATON_VIRTUAL_SCHOOL = "Katon Virtual School";
export const MYLIBRARY_TEXTS = {
  EXAMINATION_GUIDE_TEXT : "Examination Guide", 
  SYNDICATED_VIDEOS_TEXT : "Syndicated Videos",
  EBOOK_PREFIX_EXAM_GUIDE_TEXT : "E-books (Examination Guide)",
  EBOOK_PREFIX_LEARNING_MATERIALS_TEXT : "E-books (Learning Materials)",
  EBOOK_PREFIX_QUESTION_BANK_TEXT : "E-books (Question Bank)",
  IMAGES_TEXT : "Images",
  PODCAST_TEXT : "Podcast",
  VIDEOS_TEXT : "Videos",
  QUESTION_BANK_TEXT : "Question Bank",
}
export const VIDEO_CATEGORY_REQUIRED_TEXT = "Video category is required";
export const FILE_NAME_ALREADY_EXISTS_TEXT = "File with this name already exists!";
export const PODCAST_MATERIAL_TEXT = "PodcastMaterial";
export const IMAGE_MATERIAL_TEXT = "ImageMaterial";
export const QUESTION_BANK_TEXT = "Questions bank";
export const MATERIALS_TEXT = "Materials";
export const MATERIALS_ALREADY_ASSOCIATED_TEXT = "Materials are already associated";
export const SUBMITTED_ASSIGNMENTS_TEXT = "Submitted  Assignment";
export const DATA_SRC_SET = "data-src-set";
export const TEACHER_LOGIN_BOTTOM_IMAGE_NAME = "images/teacherLoginBottomImage.png";
export const PTA_SIDE_IMAGE_NAME = "images/PtaSideImage.png";
export const EXPIRY_MINUTES_VALIDATION_MESSAGE = "Minutes must be between 0 and 59";
export const PHONE_NUMBER_TEXT = "Phone Number";
export const GET_CLASS_CODE_FOR_VIRTUAL_SCHOOL_TEXT = "Get Class Code for Katon Virtual School";
export const KATON_VIRTUAL_SCHOOL_TITLE = "Katon Virtual School";

export const CHIME_TYPING_THROTTLE_MS = 1000;
export const MANUAL_LEAVE_TRIGGER = "manual";
export const AUTO_LEAVE_TRIGGER = "auto";
export const HOST_CHANGE_TRIGGER = "host-changed";
export const BUTTON_DISABLED = "button-disabled";
